document.addEventListener('DOMContentLoaded', function () {
  // Keep the sticky header (and the cart icon) visible while scrolling on desktop.
  // A rule in custom.css collapses the header when it has the 'active' class:
  //   @media (min-width:991px){ section.sticky__header.active header { height:0; opacity:0 } }
  // header.js was adding that class on scroll, which hid the cart. We now (1) never keep the
  // class and (2) inject an override so the collapse cannot happen even if the class returns.
  var override = document.createElement('style');
  override.textContent = '@media (min-width:991px){section.sticky__header.active header{height:auto !important;opacity:1 !important;padding-top:29px !important;padding-bottom:31px !important;}}';
  document.head.appendChild(override);

  var sentinel = document.querySelector('.sticky-sentinel');
  var header = document.querySelector('.sticky__header');
  if (!header) return;
  header.classList.remove('active');
  if (!sentinel) return;

  var observer = new IntersectionObserver(function () {
    header.classList.remove('active');
  }, { threshold: 0 });
  observer.observe(sentinel);
});